import axios from 'axios';
import { getListModel } from '@/utils/customizer';

export default {
  setMaterialItem({ commit, state }) {
    let index = -1;

    if (state.queryParams.model.material) {
      index = state.materials.findIndex(
        el => el.material?.vendor_code === state.queryParams.model.material,
      );
    }

    if (index !== -1) {
      commit('updateMaterialsItem', state.materials[index]);
    } else {
      // commit('updateMaterialsItem', state.materials[0]);
    }
  },

  setHeightFromModelPrice({ commit, getters }) {
    if (getters.getModelPrice) {
      commit('updateModelSizeHeight', 1000);
    }
  },

  setModelFromBasket({ commit, dispatch, state }, params) {
    commit('updateModelSizeHeight', '');
    commit('updateModelSizeWidth', '');
    for (let i = 0; i < state.models.length; i++) {
      if (state.models[i].id === params.system.id) {
        commit('updateSystem', i);
        for (let m = 0; m < state.models[i].models.length; m++) {
          if (state.models[i].models[m].id === params.model.id) {
            commit('updateModel', m);
            if (state.models[i].models[m].sub_models.length > 0) {
              for (let s = 0; s < state.models[i].models[m].sub_models.length; s++) {
                if (state.models[i].models[m].sub_models[s].id === params.model.sub_model.id) {
                  commit('updateSubModel', s);
                }
              }
            } else {
              commit('updateSubModel', 0);
            }
          }
        }
      }
    }
    dispatch('loadMaterials', {
      id:
        state.models[state.system].models[state.model].sub_models.length > 0
          ? state.models[state.system].models[state.model].sub_models[state.subModel].id
          : state.models[state.system].models[state.model].id,
    }).then(res => {
      for (let i = 0; i < state.materials.length; i++) {
        if (state.materials[i].material.id === params.material.id) {
          commit('updateMaterialsItem', state.materials[i]);
        }
      }
      commit('updateModelSizeHeight', params.height);
      commit('updateModelSizeWidth', params.width);
    });
  },

  loadModels({ commit, dispatch, state }, params) {
    return new Promise((resolve, reject) => {
      let query = params ? `?view=${params}` : '';

      axios.get(`${process.env.VUE_APP_API_URL}/api/models${query}`).then(
        res => {
          resolve(res.data);
          commit('updateModels', res.data);
          const systemIndex = res.data.findIndex(el => el.selected);

          if (systemIndex !== -1) {
            commit('updateQueryParamsSystem', systemIndex);
            commit('updateSystem', systemIndex);

            const models = state.models[systemIndex].models;
            const modelIndex = models.findIndex(el => el.selected);

            if (modelIndex !== -1) {
              const listModel = getListModel(models);
              const modelItem = models[modelIndex];
              const modelItemId = modelItem.id;
              const listModelFind = listModel.find(
                ({ id, items = [] }) =>
                  id === modelItemId || items.find(({ id }) => id === modelItemId),
              );

              commit('updateQueryParamsModel', modelIndex);

              if (listModelFind?.items?.length > 1) {
                const modelItem = models[modelIndex];

                commit('updatePreselectedModel', modelItem);
                commit('updateIsTriggerModelPopover', true);
              } else {
                commit('updateModel', modelIndex);
              }
            }

            dispatch('options/setOptionsList', '', { root: true });
          }
        },
        error => {
          reject(error);
        },
      );
    });
  },

  loadMaterials({ commit, state }, params) {
    const materialsItem = state.materialsItem;
    commit('updateMaterialsItem', null);

    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/models/${params.id}/materials`).then(
        res => {
          const list = res.data || [];
          resolve(list);
          commit('updateMaterials', list);

          if (materialsItem?.material?.id) {
            const itemFind = list.find(item => item.material.id === materialsItem.material.id);

            commit('updateMaterialsItem', itemFind);
          }
        },
        error => {
          reject(error);
        },
      );
    });
  },

  setModelsSelected({ commit, state }) {
    const system = state.queryParams.model.type;
    const model = state.queryParams.model.model;
    const sub = state.queryParams.model.sub;

    if (system) {
      commit('updateSystem', system);
    } else {
      commit('updateSystem', null);
    }

    if (model) {
      commit('updateModel', null);
    } else {
      commit('updateModel', 0);
    }

    if (sub) {
      // commit('updateSubModel', sub);
    } else {
      commit('updateSubModel', null);
    }
  },
};
